import type { Level } from "./types";

export const oniryaLevel: Level = {
  id: "onirya",
  title: "Onirya",
  word: "ONIRYA",
  copy: {
    start: "Start",
    loseTitle: "It's over. You woke up.",
    win: [
      "The mantra is not spoken. It is heard from within.",
      "Between one dream and the next there is a white that is not empty.",
      "Sleep is the oldest way to travel.",
      "Hallucination is a map too.",
      "Close your eyes. The line goes on.",
      "What you saw was not yours — it was sleep reminding you.",
      "Om is not a word. It is the place where words stop.",
      "The body stayed. Attention left.",
      "Neither waking, nor dream, nor sleep: only this.",
      "The color that filled the screen was already behind the eyelids.",
      "Waking and falling asleep are the same gesture, seen from both sides.",
      "You didn't wake. You reached the middle.",
      "Repeat until the sound is only breath.",
      "Deep sleep has no images. Only tone.",
    ],
    lose: [
      "The line took the dream.",
      "The middle filled. The rest was left outside.",
      "The seam closed over you.",
      "What arrives alone does not meet. It stays in the seam.",
      "One half without the other only fattens the middle.",
      "Two dreams in the same place. The rest is food.",
      "The line eats what goes unrecognized.",
      "It wasn't meant for the line. It was meant for the other side.",
      "One side calls. The other must arrive in time.",
      "The pair crosses. The unpaired stay.",
      "The line's hunger is the absence of a pair.",
      "To arrive late to the other is not to arrive at all.",
      "The meeting keeps the sleep. The rest wakes the middle.",
      "One side took the room. The other went dark.",
    ],
  },
  rules: {
    score: { type: "meet-pair" },
    win: { type: "score" },
    lose: { type: "divider-or-region", fraction: 0.7 },
    extras: [],
  },
  objects: [],
  audio: {
    bed: "synth-am",
    sources: [],
  },
  world: {
    divider: {
      /** Grossura da costura a que se perde. Independente do Limen. */
      thicknessMax: 280,
      spaceLoseAt: 0.7,
    },
  },
};
